import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _types$SET_CART_SUCCE;
import * as types from './types';
export default (_types$SET_CART_SUCCE = {}, _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_SUCCESS, function (state, payload) {
  state.success = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_SUCCESS_SERVER, function (state, payload) {
  state.successServer = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART, function (state, payload) {
  state.items = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_QTY, function (state, payload) {
  state.total = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_STATE, function (state, payload) {
  state.cartState = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_SELLER_ID, function (state, sellerId) {
  state.sellerId = sellerId;
}), _types$SET_CART_SUCCE);